import {
  EMPLOYEE_CHANGESHIFT_FETCHING,
  EMPLOYEE_CHANGESHIFT_SUCCESS,
  EMPLOYEE_CHANGESHIFT_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_CHANGESHIFT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_CHANGESHIFT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_CHANGESHIFT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
